import React from 'react';
import './Footer.css';
import Logo from '../../assets/images/logo/xenvota-logo.svg';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src={Logo} alt="Xenvota" className="footer-logo" />
            <p className="footer-tagline">Building scalable, future-ready software solutions</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><a href="#services">Mobile Development</a></li>
                <li><a href="#services">Web Development</a></li>
                <li><a href="#services">API Integration</a></li>
                <li><a href="#services">Cloud & DevOps</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li>
                  <a href="/#/about">About Us</a>
                </li>
                <li>
                  <a href="#products">Our products</a>
                </li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Contact</h4>
              <p>Need help or have a question?</p>
              <p>Drop us a message at <a href="mailto:support@Xenvota.Com">support@Xenvota.Com</a></p>
              <p>Call us at <a href="tel:+918800931207">+91 8800931207</a> | <a href="tel:+919588288100">+91 9588288100</a></p>
              <p>Send us <a href="#contact">your query</a> and our team will help you shortly</p>
            </div>

          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2025 Xenvota Tech Solutions. All rights reserved.</p>
          </div>
          <div className="footer-legal">
            <a href="/#/privacy-policy">Privacy Policy</a>
            <a href="/#/terms-and-conditions">Terms & Conditions</a>
            <a href="/#/refund-policy">Refund Policy</a>
            <a href="/#/shipping-policy">Shipping Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 